import { ReactNode } from "react";
import {
  useMerchantApiQueryWithParams,
  useReactRouterLink,
} from "../../../hooks";
import { useParams } from "react-router-dom";
import { IModalFormProps, IViewCustomer } from "../../../interfaces-and-types";

import { View } from "./View";
export interface ICustomerDetailsModalViewProps extends IModalFormProps {
  modalData: IViewCustomer | null;
  customerPaymentsSearchQuery?: string | null;
  enableSearchCustomerPayments: boolean;
  invoiceData: ReactNode[];
  subscriptionData: ReactNode[];
}

export const CustomerDetailsModal = () => {
  const { location, navigateToRoutePreserveParams } = useReactRouterLink();

  const closeModal = () => {
    navigateToRoutePreserveParams(
      location.pathname.replace(`/${id}/details`, "")
    );
  };

  const { id } = useParams();

  const {
    isLoading: isLoadingCustomer,
    isSuccess: isSuccessCustomer,
    isError: isErrorCustomer,
    data: customer,
  } = useMerchantApiQueryWithParams<{ id: string }, IViewCustomer>(
    [
      "getCustomerById",
      {
        id: id!, // NOTE: used to enforce react query cache with correct queryKey
      },
    ],
    {
      enabled: !!id,
    },
    (urlTemplate) => urlTemplate.replace("id", id!)
  );

  return (
    <View
      isLoadingModalData={isLoadingCustomer}
      isErrorModalData={isErrorCustomer}
      isModalOpen={!!id}
      closeModal={closeModal}
      modalData={customer || null}
      customerPaymentsSearchQuery={customer?.email}
      enableSearchCustomerPayments={isSuccessCustomer}
      invoiceData={[]}
      subscriptionData={[]}
    />
  );
};
